let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8NLHL")).then(() => parcelRequire('4AQDU'));